export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};
export const isStage = (): boolean => {
  return process.env.NEXT_ENV === 'staging';
};
export const isNext = (): boolean => {
  return process.env.NEXT_ENV === 'next';
};

export const isProduction = (): boolean => {
  return process.env.NEXT_ENV === 'production';
};

export const isMeetButterIO =
  process.env.REACT_APP_SHOW_BUTTER_REDIRECT === 'true';

export const currentEnvironment = (): string => {
  if (isDevelopment()) {
    return 'development';
  }
  if (isStage()) {
    return 'staging';
  }
  if (isNext()) {
    return 'next';
  }
  if (isProduction()) {
    return 'production';
  }

  return 'development';
};

export const getHostname = (): string => {
  return typeof window !== 'undefined'
    ? window.location.origin
    : 'https://butter.us';
};
export const getCurrentLocation = ({
  fallback = '',
}: {
  fallback?: string;
}): string => {
  return typeof window !== 'undefined'
    ? window.location.href
    : `${getHostname()}${fallback}`;
};
